export const base64Decode = (base64Str: string): string => {
  const buffer = Buffer.from(base64Str, "base64");
  return buffer.toString("utf-8");
};
